// Copyright ©️ 2026 eVolve MEP, LLC

import { type FacilityId, useEvolvePost } from '@evolvemep/api-ts';
import { notifications } from '@mantine/notifications';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = ModalRegistryManagedProps & {
  facilityId: FacilityId;
  onDraftApplied: () => Promise<void>;
};

export const SaveDraftChangesModal = ({ facilityId, onDraftApplied, ...props }: Props) => {
  const { apiCall: applyDraftShopConfigurationApiCall } = useEvolvePost(
    `shop/configuration/${facilityId}/draft/set-current`,
  );
  return (
    <WrappedModal
      title="Save changes"
      onConfirm={async () => {
        await applyDraftShopConfigurationApiCall({});
        await onDraftApplied();
        notifications.show({
          title: 'Successfully updated',
          message: 'New work cell setup changes saved.',
          color: 'green',
        });
      }}
      {...props}
    >
      Are you ready to save your changes? Doing so will rebalance your work cells. This may take some time.
    </WrappedModal>
  );
};
